import { Filter, Plus } from 'assets/icons';
import AdminSearchInput from 'components/AdminSearch/AdminSearchInput';
import Button from 'components/button';
import PillTabs from 'components/tabs/PillTabs';
import Tooltips from 'components/tooltips/Tooltips';
import useText from 'hooks/useText';
import ViewToggle from 'components/viewToggle/ViewToggle';

/**
 * The bar over the tasks: « À faire », « Terminées » and « Supprimées » (the table only), the
 * search, whose tasks they are (`people`, an agency manager's choice), the
 * switch of view, the filters and the button that adds a task (also the N key).
 */
const TasksToolbar = ({ view, tab, todoCount, query, filterCount, people, onTab, onQuery, onView, onFilter, onAdd }) => {
  const { text } = useText('tasks');
  return (
    <div className="flex shrink-0 flex-wrap items-center gap-4 px-4 py-3 lg:px-8">
      {view === 'list' && (
        <PillTabs
          activeTab={tab}
          onChange={onTab}
          tabs={[
            { id: 'todo', label: text('tabTodo'), count: todoCount },
            { id: 'done', label: text('tabDone') },
            { id: 'deleted', label: text('tabDeleted') },
          ]}
        />
      )}
      <div className="w-[230px]">
        <AdminSearchInput
          value={query}
          placeholder={text('search')}
          onChange={(event) => onQuery(event.target.value)}
        />
      </div>
      <span className="flex-1" />
      {/* The controls on the right sit closer together than the bar's parts. */}
      <div className="flex flex-wrap items-center gap-2">
        {people}
        <ViewToggle view={view} onChange={onView} />
        {/* The filters do not apply to « Supprimées » (the search does): no button there. */}
        {!(view === 'list' && tab === 'deleted') && (
          <Button color="SECONDARY" size="SM" className="shrink-0" onClick={onFilter}>
            <Filter wh={16} color="#374151" />
            <span>
              {text('filter')}
              {filterCount > 0 ? ` (${filterCount})` : ''}
            </span>
          </Button>
        )}
        <Tooltips text={text('addTooltip')} placement="bottom">
          <Button color="PRIMARY" size="SM" className="h-10 shrink-0" onClick={onAdd}>
            <Plus wh={18} color="currentColor" />
            <span>{text('add')}</span>
          </Button>
        </Tooltips>
      </div>
    </div>
  );
};

export default TasksToolbar;
